import React, { Component } from "react";
import PropTypes from 'prop-types';

import {Field, reduxForm, change} from 'redux-form';
import {connect} from 'react-redux';
import { getRoomById, addRoom, updRoom, addRoomByCommunity } from '../../actions/roomAction';
import { getAllItems } from '../../actions/itemAction';
import { renderTextField } from '../../utils/engageComponents'
import Grid from '@material-ui/core/Grid';
import { Tab, Tabs } from '@material-ui/core';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { sweetAlert } from "../../components/Alert/sweetAlert";

import {
    ADD_ROOM_SUCCESS,
    UPDATE_ROOM_SUCCESS
} from "../../constants/roomConstant";

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The Room must have less than ${props.characterLimit} characters`
    }

    return errors;
};

  const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={1}>
            <Grid>{children}</Grid>
          </Box>
        )}
      </div>
    );
  };

  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };



class AddEditRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props.data._id,
            items : props.items,
            itemsByRoom: this.props.data.items ? [...this.props.data.items]: [],
            openModal:false,
            nameEs:'',
            nameFr:'',
            tab:0
        };

        if (props.data) {
            this.props.dispatch(change('RoomForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('RoomForm', 'name', props.data && props.data.name));
        } else {
            this.props.dispatch(change('RoomForm', '_id', ''));
            this.props.dispatch(change('RoomForm', 'name', ''));
        }
    }

    //This method will run once the component is deploy to the browser
    componentDidMount(){
        if(this.props.data !== ''){
            this.props.getRoomById(this.props.data._id)
        }

        this.setState({commonRoom: (this.props.data && this.props.data.isCommonRoom)? true: false});

        this.props.getAllItems();

        if(this.props.data?.translations && this.props.data.translations.length>0){

            const spanishObj = this.props.data.translations.find(x=>x.languageCode==='es');

            const frenchObj = this.props.data.translations.find(x=>x.languageCode==='fr');
            
            if(spanishObj){
                this.setState({nameEs:spanishObj.name});

                this.props.dispatch(change('RoomForm','nameEs', spanishObj.name)) ;

            }

            if(frenchObj){
                this.setState({nameFr:frenchObj.name});
                this.props.dispatch(change('RoomForm','nameFr', frenchObj.name)) ;

            }

        }        
    }

    //This methos is responsable to handle the click in cancel button 
    //it does set state prop OPEN to false so in a rerender this component will not be render (it render the list of rooms)
    //set the prop itemsByroom to []
    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.setState({ itemsByRoom: [] })
            this.props.closeDialog();
        }
    };

    //This method handle the click in save button and depending on if state._id is defined it call method update else it call add method
    //and call closeDialog send as a property by Room.jsx
    onSubmitHandler = (formData) => {
        formData.items = this.state.itemsByRoom

        if (formData.name.length > this.props.characterLimit) {
            const message = `The room must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditRoom_CharacterLimit_Error');
            return;
        }

        formData.translations=[];

        if(this.state.nameEs!==''){
            const spanishObj={
                languageCode:'es',
                name:this.state.nameEs,
            }

            formData.translations.push(spanishObj);
        }

        if(this.state.nameFr!==''){
            const frenchObj={
                languageCode:'fr',
                name:this.state.nameFr,
            }

            formData.translations.push(frenchObj);
        }

        formData.isCommonRoom =  this.state.commonRoom;

        if(!this.state._id){
            this.props.addRoomByCommunity(formData, localStorage.getItem('communityId')); //this.state._id);
        }else {
            this.props.updRoom(this.state._id, formData); //this.state._id);
        }

        this.setState({ itemsByRoom: [] })
    };


    //this method handle the check of the checkboxes in the list of rooms
    handleToggle = (value) => {
        if (!this.state.itemsByRoom) {
            const newChecked = [];
            newChecked.push(value);

            this.setState({ itemsByRoom: newChecked })
        } else {
            const currentIndex = this.state.itemsByRoom.indexOf(value);
            const newChecked = this.state.itemsByRoom;

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }

            this.setState({ itemsByRoom: newChecked })
        }

        this.isSwitchChecked();
    };


    //This methos select every element in the list and put them in the itemsByRoom array 
    handleChange = (event) => {
        //setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked)
            this.setState({ itemsByRoom: this.props.items.map(item => item._id) })
        else
            this.setState({ itemsByRoom: [] })
    };

    //handle the state of the switch
    isSwitchChecked = () => {
        let isChecked = false;

        if (this.props.items && this.state.itemsByRoom) {
            isChecked = !this.props.items.some((i) => this.state.itemsByRoom.indexOf(i._id) === -1);
        }
        return isChecked;
    }

    handleChangeTab = (event, newValue) => {
        this.setState({tab:newValue});
    };

    a11yProps(lng) {
        return {
          id: `vertical-translation-tab-${lng}`,
          'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex =(index)=>{
        this.setState({tab:index})
    }

    //#region components
    ResidentLocationComponent = () =>{
        //if is common room the checkbox should by checked
        const isChecked = this.state.commonRoom? false : true;
        
        return(
            <>
                <Grid item container xs={1} justify="center" alignContent="center">
                    <Grid item className='CheckboxBlue RepairsCell'>
                        <Checkbox
                            id={`commonRoom_checkbox`}
                            checked={isChecked}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {this.setState((prevState) => ({commonRoom: !prevState.commonRoom}))}}
                            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                            checkedIcon={
                                <CheckBoxIcon fontSize="large" />
                            }
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={10} justify='flex-start' alignContent="center" style={{color:'#b9b9bb'}}>
                    <Grid item>
                        Display this room as an option for residents on their TV. Uncheck if a common area (i.e. Lobby, Dining Room, etc.)
                    </Grid>
                </Grid>
            </>
        )
    }
    //#endregion 

    //#region methods
    //#endregion
    
    render() {
        const { handleSubmit } = this.props;

        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isRoomSuccess.success && (this.props.isRoomSuccess.type === ADD_ROOM_SUCCESS || this.props.isRoomSuccess.type === UPDATE_ROOM_SUCCESS)) {
            this.props.closeDialog(1);
        }

        return (
            <main style={{ width: '100%' }}>
                <form>
                    <Grid item container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn_rooms" className="appbtn-engage skybluebtn-engage" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id="cancel_btn_rooms" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <Grid item xs={12} sm={12} md={6} lg={6} className='formSection'>
                            <Field
                                id='rooms_add_room_name'
                                name="name"
                                label="Name"
                                maxLength={20}
                                component={renderTextField}
                                inputLabelClass='defaultTextStyles'
                                inputClass='defaultTextStyles'
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item xs={12} sm={12} md={6} lg={6} className="characterCount">When you add a new Room, be sure to assign Items to the new Room for proper display on residents' Engage systems. See Items tab above.</Grid>
                    </Grid>
                    <Grid item container xs={12} style={{paddingTop:'15px'}}>
                        <this.ResidentLocationComponent/>
                    </Grid>
                <Modal
                    open={this.props.openTranslation}
                    onClose={this.props.closeTranslations}
                >
                    <Paper elevation={3}>
                        <Grid className='translationsModal'>
                            <Grid className="ModalTitle">Add translations</Grid>
                            <Grid item container xs={12} style={{marginTop:'1rem', marginBotton:'1rem'}}>
                                <Tabs
                                    value={this.state.tab}
                                    onChange={this.handleChangeTab}
                                    aria-label="Translations tab"
                                    className='translationTabs'
                                    TabIndicatorProps={{style:{backgroundColor:'#009edd'}}}

                                >
                                    <Tab label="ES" className={(this.state.tab === 0)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(0)} />
                                    <Tab label="FR" className={(this.state.tab === 1)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(1)} />

                                </Tabs>

                                <SwipeableViews
                                    axis={'x'}
                                    index={this.state.tab}
                                    onChangeIndex={this.handleChangeTranslationIndex}
                                >

                                    <TabPanel value={0} index={0} className='translationTabContent'>
                                        <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                            <Grid item xs={12}>
                                                <Field
                                                    name="nameEs"
                                                    label="Nombre"
                                                    maxLength={20}
                                                    onChange={(e, newItem ) => this.setState({nameEs: newItem})}
                                                    component={renderTextField}
                                                    id='nameEs'
                                                />  
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                                            
                                    <TabPanel value={1} index={1} className='translationTabContent'>
                                        <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                            <Grid item xs={12}>
                                                <Field
                                                    name="nameFr"
                                                    label="nom"
                                                    maxLength={20}
                                                    onChange={(e, newItem ) => this.setState({nameFr: newItem})}
                                                    component={renderTextField}
                                                    id='nameFr'
                                                />  
                                            </Grid>
                                        </Grid>
                                    </TabPanel>

                                </SwipeableViews>

                                <Grid item container xs={12} alignItems='center' justify='center' style={{marginTop:'1rem'}}>
                                    <Grid 
                                        item container justify='center' alignItems='center'
                                        onClick={this.props.closeTranslations} 
                                        className='RepairsModalButtonCancel alingCenter'
                                    >
                                        Cancel
                                    </Grid>
                                    <Grid 
                                        item container justify='center' alignItems='center'
                                        onClick={this.props.closeTranslations} 
                                        className='RepairsModalButtonSchedule alingCenter'
                                    >
                                        Ok
                                    </Grid>
                                </Grid>

                            </Grid>

                        </Grid>
                    </Paper>
                    
                </Modal>
                </form>
            </main>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let initialValuesData = {};

    if (state.roomReducer && state.roomReducer.roomData) {
        initialValuesData._id = state.roomReducer.roomData._id
        initialValuesData.name = state.roomReducer.roomData.name
        initialValuesData.isCommonRoom = state.roomReducer.roomData.isCommonRoom
    }

    const roomSuccess = state.roomReducer;

    return {
        roomData: state.roomReducer && state.roomReducer.roomData,
        initialValues: initialValuesData,
        items: state.itemReducer.itemData,
        itemsByRoom: [],
        isRoomSuccess: roomSuccess
    };
}

export default connect(mapStateToProps, { getRoomById, addRoom, addRoomByCommunity, updRoom, getAllItems })(reduxForm({
    form: 'RoomForm',
    validate,
    enableReinitialize: true,
})(AddEditRoom));